import React from 'react'
import cls from 'classnames'

import CenteredLoader from '../lib/CenteredLoader'

import ErrorContainer from './ErrorContainer'
import PartnerAccess from './PartnerAccess'

function ChildrenWrapper({ error, children }) {
  return (
    <>
      {error && <ErrorContainer error={error} />}
      <>{children}</>
    </>
  )
}

export default function DataContainer({
  error,
  children,

  style,
  loader,
  loaderStyle,
  className,
  partnerAccess,
  onClick,
  customReasonsText,
}) {
  return (
    <div style={style || {}} onClick={onClick} className={cls(className)}>
      {loader ? (
        <CenteredLoader style={loaderStyle} />
      ) : partnerAccess ? (
        <PartnerAccess
          companyFilter={partnerAccess.companyFilter}
          checkPartnerAccess={partnerAccess.checkPartnerAccess}
          customReasonsText={customReasonsText}
          redirectPath={partnerAccess.redirectPath}
        >
          <ChildrenWrapper error={error}>{children}</ChildrenWrapper>
        </PartnerAccess>
      ) : (
        <ChildrenWrapper error={error}>{children}</ChildrenWrapper>
      )}
    </div>
  )
}
